// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "OTA commissions",
    sub: "What each channel keeps from your reservations. With this, the details of every reservation give you an estimate of what you receive.",
  },
  loading: "Loading commissions…",
  loadError: {
    title: "We couldn't load the commissions",
    text: "Check your connection and try again.",
    retry: "Retry",
  },
  display: {
    title: "OTA reservation price in the reservation details",
    totalLabel: "Only the total sent by the OTA",
    totalDesc: "As before: the reservation amount.",
    netLabel: "Also what you receive",
    netDesc: "Besides the total, the details show the commission, the VAT on the commission and the net amount you'll receive.",
  },
  rates: {
    title: "Commission and charges per OTA",
    hint: "Enter the % you see in each OTA's extranet (on Booking: \"Commission and charges\" ÷ \"Total price\"). If the channel reports the actual commission of a reservation, that one is used.",
    usual: "usual: {pct}%",
    airbnbNote: "Airbnb pays you the amount already net: its commission has been deducted. Leave it empty (0%) unless your connection receives the total.",
    managedNote: "These percentages are also used in your owner's settlement.",
  },
  vat: {
    title: "VAT on the OTA commission",
    hint: "Booking charges VAT on its commission to properties in Spain (21%) and deducts it from the payout. Enter 0 if you aren't charged it.",
  },
  errPercent: "It must be a percentage between 0 and 100.",
  example: {
    title: "Example",
    sub: "A {channel} reservation of {total}",
    total: "Total price",
    commission: "{channel} commission and charges ({pct}%)",
    vat: "VAT on the commission ({pct}%)",
    net: "You receive",
    foot: "This is an estimate based on these percentages: the OTA may transfer a slightly different amount (rounding, promotions, payment charges). If the channel reports the actual commission, the details use that one.",
  },
  footer: {
    save: "Save",
    saving: "Saving…",
    saved: "Commissions saved",
    unsaved: "Unsaved changes",
    fixErrors: "Check the highlighted fields",
    errSave: "We couldn't save the changes. Please try again.",
    errInvalid: "Each OTA commission must be a percentage between 0 and 100.",
  },
};
